var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColumns(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 14.9792,
    height: 11.6667,
    viewBox: "0 0 14.9792 11.6667",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Container"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M0 10V1.66667C0 1.20833 0.163194 0.815972 0.489583 0.489583C0.815972 0.163194 1.20833 0 1.66667 0H13.3125C13.7708 0 14.1632 0.163194 14.4896 0.489583C14.816 0.815972 14.9792 1.20833 14.9792 1.66667V10C14.9792 10.4583 14.816 10.8507 14.4896 11.1771C14.1632 11.5035 13.7708 11.6667 13.3125 11.6667H1.66667C1.20833 11.6667 0.815972 11.5035 0.489583 11.1771C0.163194 10.8507 0 10.4583 0 10V10M1.64583 10H4.41667V10V10V1.66667V1.66667V1.66667H1.64583V1.66667V1.66667V10V10V10V10M6.08333 10H8.85417V10V10V1.66667V1.66667V1.66667H6.08333V1.66667V1.66667V10V10V10V10M10.5208 10H13.2917V10V10V1.66667V1.66667V1.66667H10.5208V1.66667V1.66667V10V10V10V10",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumns);
export default __webpack_public_path__ + "static/media/columns.e9365dbe0e7f900b4ac1b63c32f3f2fd.svg";
export { ForwardRef as ReactComponent };